import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PagedAuditResponse } from './+models/audit-log.model';
import { ExpenseSkeleton, PagedExpenseAudit } from './+models/expense.audit.model';

@Injectable()
export class ExpenseAuditService {
  private readonly apiUrl = '/sdapi/post-flight/PostedFlightAudit';

  constructor(private readonly http: HttpClient) {}

  getExpenseSkeleton(expenseId: number) {
    return this.http.get<ExpenseSkeleton>(`${this.apiUrl}/ExpenseSkeleton/${expenseId}`);
  }

  getDeletedExpenseSkeletons() {
    return this.http.get<ExpenseSkeleton[]>(`${this.apiUrl}/DeletedExpenseSkeletons`);
  }

  getExpenseAudit(
    expenseId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    return this.getAuditPage<PagedExpenseAudit>(
      `Expense/${expenseId}`,
      pageNumber,
      pageSize,
      lastAuditLogId
    );
  }

  private getAuditPage<T extends PagedAuditResponse>(
    subRoute: string,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 10;
    }
    let url = `${this.apiUrl}/${subRoute}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }

    return this.http.get<T>(url);
  }
}
